const stripeConfig = {
  pk: 'pk_stripe-config',
};
export default stripeConfig;
